import { ICost } from "@/types/cost";
import { Category } from "@/models/category";
import { CostIndex } from "@/models/cost_index";
import { Site } from "@/models/site";
import { Partner } from "@/models/partner";
import { CostImage } from "@/models/cost_image";

export class Cost implements ICost {
  public id = 0;
  public name = "";
  public volume = 0;
  public value = 0;
  public memo = "";
  public unit = "";
  public company_id = 0;
  public user_id = 0;
  public site_id = 0;
  public partner_id = 0;
  public category_id = 0;
  public cost_index_id = 0;
  public is_fix = false;
  public is_verified = false;
  public accounted_at = "";
  public created_at = "";
  public updated_at = "";
  public category = new Category();
  public partner = new Partner();
  public cost_index = new CostIndex();
  public site = new Site();
  public cost_image = new CostImage();
}
